'use client';
/** @jsxImportSource @emotion/react */

import React, { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiAccordionSummary, {
  type AccordionSummaryTypeMap as MuiAccordionSummaryTypeMap,
} from '@mui/material/AccordionSummary';

type ExcludedMuiProps = '';
type CustomProps = {
  component?: ElementType;
};

type AccordionSummaryTypeMap<
  P = CustomProps,
  D extends ElementType = MuiAccordionSummaryTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiAccordionSummaryTypeMap['props'], ExcludedMuiProps> & P;
};

export type AccordionSummaryProps<
  D extends ElementType = MuiAccordionSummaryTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiAccordionSummaryTypeMap<P, D>, D>;

const AccordionSummaryComponent = (
  props: AccordionSummaryProps,
  ref: Ref<HTMLDivElement>
) => {
  return <MuiAccordionSummary {...props} ref={ref} />;
};

AccordionSummaryComponent.displayName = 'AccordionSummary';

export const AccordionSummary = forwardRef(
  AccordionSummaryComponent
) as OverridableComponent<AccordionSummaryTypeMap>;
